import { useMutation } from "@tanstack/react-query";
import { useAuth } from "src/components/utils/auth/assist/authContext";
import useAccount from "src/hooks/useAccount";

interface CardPreviewLinkResponse {
  signedUrl: string;
}

export const useInkedCardPreviewUrl = () => {
  const { user } = useAuth();
  const { data: accountData } = useAccount();

  return useMutation({
    mutationFn: async (contactExternalId: string): Promise<string> => {
      console.log("useInkedCardPreviewUrl: contactExternalId:", contactExternalId);
      console.log("useInkedCardPreviewUrl: hostname:", window.location.hostname);

      // Use different endpoints based on environment
      if (window.location.hostname === "localhost") {
        // Ensure account data is loaded before making the request
        if (!accountData?.customer_id) {
          throw new Error("Account data not loaded yet");
        }

        // On localhost, use the direct Inked API with vendor headers
        const apiUrl = `${process.env.REACT_APP_INKED_API_URL}/vendor/card-preview-link`;
        console.log("useInkedCardPreviewUrl: Using localhost path, apiUrl:", apiUrl);

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Vendor-Key": process.env.REACT_APP_INKED_VENDOR_KEY || "",
          },
          body: JSON.stringify({
            contact_external_id: contactExternalId,
            user_email: user?.email || "",
            user_external_id: String(accountData.customer_id),
          }),
        });

        if (!response.ok) {
          throw new Error(`API request failed: ${response.status}`);
        }

        const data: CardPreviewLinkResponse = await response.json();
        return data.signedUrl;
      } else {
        // In production, use the Landvoice API endpoint
        console.log("useInkedCardPreviewUrl: Using production path");
        const response = await fetch("/api/inked/card-preview-link", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            contact_external_id: contactExternalId,
          }),
        });

        if (!response.ok) {
          throw new Error(`API request failed: ${response.status}`);
        }

        const data: CardPreviewLinkResponse = await response.json();
        return data.signedUrl;
      }
    },
  });
};
